// @ts-expect-error togeojson has no types
import { kml } from '@tmcw/togeojson/dist/togeojson.es';
import { Feature, Geometry } from 'geojson';
import { asQuantityWithUnit } from './formatters';

const parsedKmlToFeatures = (parsedKml: Document, validTypes: string[]) => {
  const errors = <string[]>[]; // Features with errors are skipped
  const warnings = <string[]>[];
  let geomCollections = false;

  const parsedFeatures = kml(parsedKml);
  const validFeatures = parsedFeatures.features
    // Flatten any GeometryCollection into individual features
    .flatMap((feature: Feature) => {
      const { geometry } = feature;
      if (geometry.type === 'GeometryCollection') {
        geomCollections = true;
        return geometry.geometries.map((geo: Geometry) => ({
          ...feature,
          geometry: geo,
        }));
      }
      return [feature];
    })
    // Validate all features for the given layer
    .flatMap((feature: Feature, i: number) => {
      const { name: displayName = `Feature ${i + 1}` } =
        feature?.properties || {};
      try {
        const { type, geometry } = feature;
        if (type !== 'Feature') {
          errors.push(`${displayName}: element has invalid type ${type}.`);
          return [];
        }
        if (geometry == null) {
          errors.push(`${displayName}: feature has invalid geometry.`);
          return [];
        }
        if (validTypes && !validTypes.includes(geometry.type)) {
          errors.push(
            `${displayName}: geometry type must be a ${validTypes.join(
              ' or ',
            )}.`,
          );
          return [];
        }
        return [feature];
      } catch (err) {
        console.error(err);
        errors.push(`${displayName}: element could not be parsed.`);
        return [];
      }
    });

  if (!validFeatures.length) {
    warnings.push('No valid features found.');
  }
  if (geomCollections) {
    warnings.push(
      'GeometryCollection elements converted to individual features.',
    );
  }

  const info =
    warnings.length + errors.length
      ? `Imported ${asQuantityWithUnit(
          'valid features',
          'valid feature',
        )(validFeatures.length)}. ${asQuantityWithUnit(
          'features',
          'feature',
        )(
          parsedFeatures.features.length - validFeatures.length,
        )} discarded due to errors.`
      : undefined;

  return { features: validFeatures, info, warnings, errors };
};

export default parsedKmlToFeatures;
